import { render, staticRenderFns } from "./leadshow.vue?vue&type=template&id=1e6a1e12&scoped=true"
import script from "./leadshow.vue?vue&type=script&lang=js"
export * from "./leadshow.vue?vue&type=script&lang=js"
import style0 from "./leadshow.vue?vue&type=style&index=0&id=1e6a1e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6a1e12",
  null
  
)

export default component.exports